<template>
  <div id="login">
    <div class="home-head">
      <head-common :nav-list="navList1" :indexProp="indexProp1"></head-common>
    </div>
    <div class="login-content">
      <div class="has-login" v-if="loginUserInfo && loginUserInfo.id ">
        <div class="has-login-cell">
          <h3>您已登录：{{loginUserInfo.username}}</h3><span @click="logout">logout</span>
        </div>
        <h4>欢迎您的到来~~</h4>
      </div>
      <form name="login-form2" v-else>
        <table>
          <tr>
            <th>账 号：</th>
            <td> <input type="text" v-model="user.username" placeholder="请输入帐号"/></td>
          </tr>
          <tr>
            <th>密 码：</th>
            <td><input type="password" v-model="user.password" placeholder="请输入密码"/></td>
          </tr>
          <tr><td class="button"><input type="submit" value="login"  @click="loginAuth"/></td></tr>
<!--          <tr><td class="button"><input type="button" value="login"/></td></tr>-->
        </table>
      </form>
    </div>
    <div class="home-footer">
      <footer-common></footer-common>
    </div>
  </div>
</template>

<script>
  import {
    logout, authServerToken, loginStatus, oauthToken, testUrlGetAuthServerPuk
  } from "./../../api/api";
  import {setLocalStorage, getLocalStorage, setLocalStorageToJsonString, deleteLocalStorage, clearToken} from "./../../utils/CommonUtil";
  import {loginUserKey, userInfo} from "./../../utils/Config";
  import {getUserInfo} from './../../utils/UserUtil'
  import FooterCommon from "../FooterCommon";
  import HeadCommon from "../HeadCommon";

  export default {
    name: "userLogin",
    components: {HeadCommon, FooterCommon},
    methods: {
      loginAuth: function () {
        console.log(this.user);
        const res = authServerToken(this.user);
        res.then((x) => {
          console.log(x);
          this.responseData.authTokenData = x;
          debugger;
          if (this.responseData.authTokenData.status === 200 && this.responseData.authTokenData.data.code === 200) {
            let token = this.responseData.authTokenData.data.data;
            console.log(this.user.username + "-token" + ":" + token);
            if (token) {
              userInfo.username = this.user.username;
              debugger;
              setLocalStorageToJsonString(loginUserKey, userInfo);
              setLocalStorage(this.user.username + "-token", token);
              this.loginStatus();
            }
          }
          console.log("getLocalStorage:" + userInfo.username, getLocalStorage(userInfo.username + "-token"));
        })
      },
      loginStatus: function () {
        const res = loginStatus();
        res.then((x) => {
          console.log(x, 'loginStatus');
          this.responseData.loginStatus = x;
          if (this.responseData.loginStatus.data.code === 200) {
            userInfo.username = this.responseData.loginStatus.data.data.username;
            userInfo.id = this.responseData.loginStatus.data.data.id;
            this.loginUserInfo.id = userInfo.id;
            this.loginUserInfo.username = userInfo.username;
            setLocalStorageToJsonString(loginUserKey, userInfo);
          }
          if (this.responseData.loginStatus.data.code === 403) {
            clearToken(loginUserKey);
          }
          console.log(getLocalStorage(loginUserKey));
          console.log(getUserInfo());
        }).catch(reason => {

        })
      },
      logout: function () {
        const res = logout();
        res.then((x) => {
          console.log(x, 'logout-x');
          this.responseData.logoutTokenData = x;
          if (this.responseData.loginStatus.data.code === 200) {
            this.loginUserInfo.id = null;
            this.loginUserInfo.username = "";
            if (this.loginUserInfo.id === null) {
              clearToken(loginUserKey);
            }
          }
        })
      },
    },
    data: function () {
      return {
        indexProp1: 0,
        navList1: [
          {routeName: "userLogin", navName: "登录", onClickOne: true},
          {routeName: "UserInfo", navName: "其他", onClickOne: false},
          {routeName: "Study", navName: "学习", onClickOne: false},
          {routeName: "home", navName: "首页", onClickOne: false}
        ],
        user: {
          username: "",
          password: ""
        },
        loginUserInfo: {
          id: null,
          username: ""
        },
        responseData: {
          loginStatus: {
            data: {
              code: 200,
              data: {
                username: "",
                id: null
              }
            }
          },
          authTokenData: {
            status: 200,
            data: {
              code: 200,
              data: ""
            }
          },
          logoutTokenData: {
            status: 200,
            data: {
              code: 200,
              data: ""
            }
          }
        }
      }
    },
    created() {
      this.loginStatus();
    }
  }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #login {
    width: 1000px;
    /*height: 1770px;*/
    border-width: 0;
    border-style: dotted;
    border-color: aqua;
    background: rgba(178, 255, 166, 0.44);
  }
  #login .login-content {
    display: table;
    width: 100%;
    min-height: 500px;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content .has-login{
    display: table-cell;
    vertical-align: middle;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content .has-login .has-login-cell{
    display: table;
    vertical-align: middle;
    width: auto;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content .has-login h3{
    display: table-cell;
    vertical-align: middle;
    width: auto;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content .has-login span{
    display: table-cell;
    flex-direction: row;
    vertical-align: middle;
    width: auto;
    padding: 5px;
    background: #ff8f65;
    color: #2e22ff;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content .has-login span:hover{
    background: #ffe9e9;
  }
  #login .login-content .has-login span:active{
    background: #ffe9e9;
    color: #9fc1ff;
  }
  #login .login-content form{
    display: table-cell;
    vertical-align: middle;
    border-style: dashed;
    border-color: #797979;
    border-width: 1px;
  }
  #login .login-content form table{
    display: flex;
    flex-direction: column; /*竖直方向布局*/
    vertical-align: middle;
    width: 35%;
    margin-left: auto;
    margin-right: auto;
    border-style: solid;
    border-width: 2px;
    border-radius: 10px;
    border-color: #65e0ed;
    box-shadow: 0 0 20px #65e0ed;/*x y 模糊 颜色阴影*/
    transition: font-size 0.1s ease-in-out;
    background: #5bdaf9;
  }
  #login .login-content form table tr{
    display: flex;
    flex-direction: row; /*横向布局*/
    vertical-align: middle;
    width: 100%;
    line-height: 2.2em;
    font-size: 2.0em;
    border-style: dashed;
    border-color: #797928;
    border-width: 0px;
  }
  #login .login-content form table tr th{
    display: inline-block;
    width: 60%;
    border-style: dashed;
    border-color: #9ecaed;
    border-width: 1px;
    border-radius: 3px;
  }
  #login .login-content form table tr td{
    display: inline-block;
    width: 100%;
    border-style: dashed;
    border-color: #9ecaed;
    border-width: 1px;
    border-radius: 3px;
  }
  #login .login-content form table input{
    display: inline-block;
    width: 90%;
    line-height: 1.5em;
    font-size: 1.2em;
    background: #2addde;
    border-radius: 10px;
    box-shadow: 0 0 10px #65e0ed;/*x y 模糊 颜色阴影*/
  }
  #login .login-content form table .button input {
    display: inline-block;
    color: #382b22;
    text-transform: uppercase;/*定义仅有大写字母。*/
    padding: 0.75em 1.25em;
    border: 2px solid #b18597;
    box-shadow: 0 0 20px #7f65ed;/*x y 模糊 颜色阴影*/
  }
  #login .login-content form table .button input::before {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f9c4d2;
    border-radius: inherit;
  }
  #login .login-content form table .button input:hover {
    background: #ffe9e9;
    box-shadow: 0 0 20px #ed2c48;/*x y 模糊 颜色阴影*/
  }
  #login .login-content form table .button input:active {
    background: #ffe9e9;
    color: #9fc1ff;
  }
  #login .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }

</style>




// WEBPACK FOOTER //
// src/components/user/userLogin.vue